import { useContext } from "react";
import EventContext from "../contexts/EventContext";

export function useEventContext() {
    return useContext(EventContext);
}